import React from 'react';
import { useSelector } from 'react-redux';
import { AnalyticsTab } from './analytics/AnalyticsTab';
import { TeamBio } from './analytics/team-overview/TeamBio';
import TeamProjects from './team-projects/TeamProjects';
import { PillarsTab } from './interventions/PillarsTab';
import { FocusPlanTab } from './interventions/action-planner/FocusPlanTab';
import featureSlice from 'common/slices/featureSlice';

interface CultureHubContentProps {
  activeTab: 'bio' | 'analytics' | 'pillars' | 'interventions' | 'team-projects';
}

const CultureHubContentComponent: React.FC<CultureHubContentProps> = ({
  activeTab,
}) => {
  const features = useSelector(featureSlice.selectors.getFeatures);
  const isBioTabEnabled = features.some(f => f.name === 'Culture Hub Bio' && f.enabled);

  return (
    <div style={{
      minHeight: 'calc(100vh - 150px)',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    }}>
      {activeTab === 'bio' && isBioTabEnabled && <TeamBio />}
      {activeTab === 'analytics' && <AnalyticsTab />}
      {activeTab === 'pillars' && <PillarsTab />}
      {activeTab === 'interventions' && <FocusPlanTab />}
      {activeTab === 'team-projects' && <TeamProjects />}
    </div>
  );
};

export const CultureHubContent = React.memo(CultureHubContentComponent);
